// /utils/reports/proval/samDefectsLong.js

/**
 * SAM Defects Long Continuous Export
 * Source: segments exceeding IRI threshold (excluding exceptions)
 * Output: Two tables (Left Profile, Right Profile) in same file
 */

function sanitizeFilename(str) {
  return str.replace(/[^a-zA-Z0-9-_]/g, '_').substring(0, 50);
}

export function generateSAMDefectsLong(segments, options = {}) {
  const { format = 'txt', threshold = 160 } = options;
  const delimiter = format === 'csv' ? ',' : '\t';
  
  // Sort all segments to find true session start
  const allSorted = [...segments].sort((a, b) => a.from_station_ft - b.from_station_ft);
  const sessionStart = allSorted[0]?.from_station_ft ?? 0;
  
  // Filter to non-exception segments only
  const validSegments = allSorted.filter(seg => !seg.exception);
  
  // Filter segments exceeding threshold for each wheelpath
  const leftDefects = validSegments.filter(seg => 
    seg.iri_left_in_per_mi != null && seg.iri_left_in_per_mi > threshold
  );
  
  const rightDefects = validSegments.filter(seg => 
    seg.iri_right_in_per_mi != null && seg.iri_right_in_per_mi > threshold
  );
  
  const headers = ['Start Distance (ft)', 'Stop Distance (ft)', 'IRI (in/mi)'];
  const lines = [];
  
  // Left Profile table
  lines.push('Left Profile');
  lines.push(headers.join(delimiter));
  
  if (leftDefects.length === 0) {
    lines.push('(No defects)');
  } else {
    leftDefects.forEach(seg => {
      lines.push([
        (seg.from_station_ft - sessionStart).toFixed(1),
        (seg.to_station_ft - sessionStart).toFixed(1),
        seg.iri_left_in_per_mi?.toFixed(2) ?? ''
      ].join(delimiter));
    });
  }
  
  lines.push(''); // Blank line separator
  
  // Right Profile table
  lines.push('Right Profile');
  lines.push(headers.join(delimiter));
  
  if (rightDefects.length === 0) {
    lines.push('(No defects)');
  } else {
    rightDefects.forEach(seg => {
      lines.push([
        (seg.from_station_ft - sessionStart).toFixed(1),
        (seg.to_station_ft - sessionStart).toFixed(1),
        seg.iri_right_in_per_mi?.toFixed(2) ?? ''
      ].join(delimiter));
    });
  }
  
  return lines.join('\n');
}

export function getSAMDefectsLongFilename(session, format = 'txt') {
  const name = sanitizeFilename(session?.name || 'Session');
  return `SAM_Defects_Long_Continuous_${name}.${format}`;
}